// Strings for the catering menu + recipes import (kitchen flow, go-live).
export const MI = {
  title: 'Catering menu & recipes',
  help: 'Add or update many dishes at once, each with its recipe, from one spreadsheet. Without a recipe a dish adds nothing to the kitchen sheet.',
  open: 'Import menu & recipes',
  close: 'Close',
  step1: 'One row per ingredient: dish, category, price per serving (what one serving sells for — a booking charges servings × this price, so never the price of the whole pot), order type (all / dine_in / takeaway), ingredient (the stock item’s exact name), qty, unit (g, kg, ml, l, each) and, if the amounts are for a whole pot, how many servings it makes. To change only a dish’s price or category, list it with no ingredients: it keeps its current recipe.',
  download: 'Download the template',
  choose: 'Choose the filled file (.csv)',
  checking: 'Checking every row…',
  summary: (ok: number, bad: number) => `${ok} dish${ok === 1 ? '' : 'es'} ready${bad ? ` · ${bad} with problems` : ''}`,
  fixFirst: 'Fix the red rows in the file and choose it again — nothing is saved while any dish has a problem.',
  unknown: (names: string[]) => `Not in stock under that name: ${names.join(', ')}. Use the stock item’s exact name, or add the item first.`,
  newCategories: (names: string[]) => `New categories will be made: ${names.join(', ')}`,
  colDish: 'Dish',
  colPrice: 'Price per serving',
  perServing: (price: string) => `${price} per serving`,
  colRecipe: 'Recipe (per serving)',
  colResult: 'Result',
  create: 'New dish',
  update: (n: number) => (n ? `Update — replaces ${n} recipe line${n === 1 ? '' : 's'}` : 'Update'),
  keepsRecipe: 'Update — keeps its current recipe',
  duplicates: (names: string[]) => `More than one menu item has the same name: ${names.join(', ')}. Rename one on the Menu screen so the file names just one.`,
  priceChange: (from: string, to: string) => `${from} → ${to}`,
  viaMerge: 'merged brand',
  scope: { all: '', dine_in: 'dine-in only', takeaway: 'takeaway only' } as Record<string, string>,
  makes: (n: number) => `recipe makes ${n}`,
  confirm: (n: number) => `Import ${n} dish${n === 1 ? '' : 'es'}`,
  importing: 'Importing…',
  done: (created: number, updated: number) => `${created} created, ${updated} updated`,
} as const
